import { gql } from "@apollo/client";

export const GET_PROPOSAL_CONFIGURATION = gql`
  query ProposalSnapshot($id: ID) {
    proposal(id: $id) {
      settings {
        configuration {
          formData
          builder
          productsConfig
          commonProductsConfiguration
        }
      }
    }
  }
`;
